export const TableCountText = ({
  total,
  page,
  pageSize,
  isLoading = false,
}: {
  total: number;
  page: number;
  pageSize: number;
  isLoading?: boolean;
}) => {
  let text = `Showing ${(page - 1) * pageSize + 1}-${Math.min(page * pageSize, total)} of ${total}`;
  if (isLoading) {
    text = "Loading...";
  } else if (total === 0) {
    text = "No URLs";
  }

  return (
    <div>
      <span className="text-sm text-gray-600">{text}</span>
    </div>
  );
};

export default TableCountText;
